import ExaminationAddQuestionButton from './ExaminationAddQuestionButton';

export default ExaminationAddQuestionButton;
